import {
    _Props10,
    useDynamicTokens, useUserTokens,
} from '@reservoir0x/reservoir-kit-ui'

import { generateCDNUrl } from './assets';

type TokenData = ReturnType<typeof useDynamicTokens>['data'][0] | ReturnType<typeof useUserTokens>['data'][0] | null;

/**
 * Check if a token is soulbound.
 * @param {Object | null} token - The token object.
 * @returns {boolean} True if the item is soulbound, false otherwise.
 */
export const isTokenSoulbound = (token: TokenData) => {
    if (token === null) {
        return false;
    }
    const soulboundAttribute = token?.token?.attributes?.find((a) => a.key === 'soulbound');
    return soulboundAttribute && soulboundAttribute?.value === 'true';
}

export const getUpdatedToken = (token: _Props10) => {
    const tokenMediaSize = 520;
    return {
        ...token,
        // @ts-ignore [MU] Prevents from erroring even when token definition is correct
        token: {
            ...token?.token,
            media: generateCDNUrl(token?.token?.media ?? '', {
                width: tokenMediaSize,
                height: tokenMediaSize,
            }),
        },
    }
};